export default function() {
  const platform = navigator.platform.toLowerCase();
  const userAgent = navigator.userAgent.toLowerCase();
  const appVersion = navigator.appVersion.toLowerCase();

  if (
    platform.includes('win') ||
    userAgent.includes('win') ||
    appVersion.includes('win')
  ) {
    return '\r\n';
  }

  return '\n';
}
